import { Form, Input } from "antd";
import WorksApi from "Api/WorksApi/WorksApi";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { errorNotification } from "Components/MyNotification";
import React, { useEffect, useState } from "react";

export const UpdateWorkForm = ({ form, workId, onFinish }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const result = await WorksApi.getSingleWork(workId);
        if (result.status === "fail") {
          errorNotification(result.message);
          return;
        }
        if (result.status === "success") {
          const workData = result.dto;
          form.setFieldsValue({
            code: workData.code,
            title: workData.title,
            unit: workData.unit,
          });
          return;
        }
      } catch (err) {
        errorNotification(err);
      } finally {
        setIsLoading(false);
      }
    };
    if (workId) {
      fetchData();
    }
  }, [workId]);

  if (isLoading) {
    return <MyLoader centered />;
  }

  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      <Form.Item
        label="Код роботи"
        name="code"
        normalize={(value) => value?.trim()}
        rules={[{ required: true, message: "Введіть код роботи" }]}
      >
        <Input placeholder="Наприклад: A21.1" />
      </Form.Item>

      <Form.Item
        label="Назва роботи"
        name="title"
        rules={[{ required: true, message: "Введіть назву роботи" }]}
      >
        <Input placeholder="Наприклад: Монтаж кабелю" />
      </Form.Item>

      <Form.Item
        label="Одиниця виміру"
        name="unit"
        normalize={(value) => value?.trim().toLowerCase()}
        rules={[{ required: true, message: "Введіть одиницю виміру" }]}
      >
        <Input placeholder="шт / м / м² / год" />
      </Form.Item>
    </Form>
  );
};
